import { Button } from '../components/ui'

export type StudentsV2Area = 'stammdaten' | 'leistung' | 'anwesenheit'
export type StudentsV2Subtab = 'profil' | 'kontakte' | 'leistungsdaten' | 'belege' | 'kompetenzen' | 'kalender' | 'kurzzeiten'

interface SegmentOption<T extends string> {
  id: T
  label: string
}

interface StudentsV2SegmentNavProps {
  area: StudentsV2Area
  subtab: StudentsV2Subtab
  onAreaChange: (area: StudentsV2Area) => void
  onSubtabChange: (subtab: StudentsV2Subtab) => void
}

const AREA_OPTIONS: SegmentOption<StudentsV2Area>[] = [
  { id: 'stammdaten', label: 'Stammdaten' },
  { id: 'leistung', label: 'Leistung' },
  { id: 'anwesenheit', label: 'Anwesenheit' }
]

const SUBTAB_OPTIONS: Record<StudentsV2Area, SegmentOption<StudentsV2Subtab>[]> = {
  stammdaten: [
    { id: 'profil', label: 'Profil & Zugriff' },
    { id: 'kontakte', label: 'Kontakte, E-Mail & Akte' }
  ],
  leistung: [
    { id: 'leistungsdaten', label: 'Leistungsdaten' },
    { id: 'belege', label: 'Belege' },
    { id: 'kompetenzen', label: 'Kompetenzen' }
  ],
  anwesenheit: [
    { id: 'kalender', label: 'Anwesenheiten' },
    { id: 'kurzzeiten', label: 'Kurzzeitige Abwesenheiten' }
  ]
}

export default function StudentsV2SegmentNav({
  area,
  subtab,
  onAreaChange,
  onSubtabChange
}: StudentsV2SegmentNavProps) {
  return (
    <div className="space-y-3 border-b border-gray-200 px-4 py-3 dark:border-gray-700 sm:px-6">
      <div className="flex flex-wrap gap-2">
        {AREA_OPTIONS.map((option) => (
          <Button
            key={option.id}
            size="sm"
            variant={area === option.id ? 'primary' : 'outline'}
            onClick={() => onAreaChange(option.id)}
          >
            {option.label}
          </Button>
        ))}
      </div>
      <div className="flex flex-wrap gap-2">
        {SUBTAB_OPTIONS[area].map((option) => (
          <Button
            key={option.id}
            size="sm"
            variant={subtab === option.id ? 'primary' : 'outline'}
            onClick={() => onSubtabChange(option.id)}
          >
            {option.label}
          </Button>
        ))}
      </div>
    </div>
  )
}
